import JitsiMeetExternalAPI from '../plugins/jitsi';

export default class Jitsi {
  /**
   * get Logged in user details
   * initialize Jitsi
   * @returns Promise<object>
   */
  constructor(meeting, user, endCallCallback) {
    this.meeting = meeting;
    this.endCallCallback = endCallCallback;
    this.jitsiObj = {};

    if (!user) {
      this.user = {};
      this.user.firstName = 'Guest';
      this.user.lastName = 'user';
      this.user.email = 'user@guest.com';
    } else {
      this.user = user.userRecord;
    }
    if (!this.user.imageUrl || this.user.imageUrl === '') {
      this.user.imageUrl = 'https://www.connecthub.live/assets/img/default-profile.jpg';
    }

    this.options = {
      roomName: this.meeting.meetingId,
      userInfo: {
        email: `${this.user.email}`,
        displayName: `${this.user.firstName} ${this.user.lastName}`,
      },
      configOverwrite: {
        startWithVideoMuted: true,
      },
      disableInviteFunctions: true,
      avatarURL: `${this.user.imageUrl}`,
      width: '100%',
      height: '100%',
      parentNode: document.querySelector('#meet'),
    };
    this.domain = 'meet.connecthub.live';
  }

  initJitsi() {
    this.jitsiObj = new JitsiMeetExternalAPI(this.domain, this.options);
    this.jitsiObj.addEventListeners({
      incomingMessage: this.incomingMessageListener,
      outgoingMessage: this.outgoingMessageListener,
      participantRoleChanged: this.participantRoleChangedEvent,
      //   passwordRequired: this.passwordRequiredEvent,
      readyToClose: this.readyToCloseEvent,
    });
    //  this.jitsiObj.setFeatureFlag('invite.enabled', false);

    return this.jitsiObj;
  }

  readyToCloseEvent() {
    try {
      const frame = document.querySelector('#meet > iframe:first-of-type');
      frame.remove();
    } catch (err) {
      console.log('unable to remove mtg frame: ', err);
    }
    window.postMessage('endCall', '*');
    return this;
  }

  getAvailableDevices() {
    return this.jitsiObj.getAvailableDevices().then((devices) => devices);
  }

  getCurrentDevices() {
    return this.jitsiObj.getCurrentDevices().then((devices) => devices);
  }

  jitsiDispose() {
    return this.jitsiObj.dispose();
  }

  incomingMessageListener(evt) {
    console.log('incoming message', evt);
    return this;
  }

  outgoingMessageListener(evt) {
    console.log('outgoing message', evt);
    return this;
  }

  participantRoleChangedEvent(evt) {
    console.log(evt.role);
    if (evt.role === 'moderator') {
    //  this.jitsiObj.executeCommand('password', 'SpendH99@20');
      console.log(this.jitsiObj);
      console.log(evt);
      // this.jitsiObj.executeCommand('password', 'The Password');
    }
  }

  passwordRequiredEvent() {
    this.jitsiObj.executeCommand('password', 'The Password');
  }

  setDisplayName(displayName) {
    this.jitsiObj.executeCommand('displayName', displayName);
  }

  setTitle(title) {
    this.jitsiObj.executeCommand('subject', title);
  }

  setAvatar() {
    this.jitsiObj.executeCommand('avatarUrl', this.user.imageUrl);
  }
}
